import { Button, ButtonProps } from '@mui/material';
import React from 'react';

interface GenerateDocumentButtonProps extends ButtonProps {
  generateIcon: React.ReactNode;
  loading?: boolean;
  label?: string;
}

export const GenerateDocumentButton = ({
  generateIcon,
  loading,
  label = 'Vygenerovat dokument',
  ...props
}: GenerateDocumentButtonProps) => (
  <Button
    variant="text"
    color="success"
    size="medium"
    endIcon={generateIcon}
    sx={{
      width: 1,
      border: 'dashed 1px',
      borderColor: 'success.main'
    }}
    loading={loading}
    {...props}
  >
    {label}
  </Button>
);
